import React from 'react';
import i18n from 'i18next';
import CommercialProjectToggle from '../costFragments/CommercialProjectToggle';
const renderCommercialProjectToggle = _ref => {
  let {
    row: costFragment,
    column,
    tabIndex
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(CommercialProjectToggle, {
    costFragment: costFragment,
    onToggleExpand: () => {
      var _column$toggleRowExpa;
      return (_column$toggleRowExpa = column.toggleRowExpansion) === null || _column$toggleRowExpa === void 0 ? void 0 : _column$toggleRowExpa.call(column, costFragment);
    },
    isExpanded: costFragment['row_expanded']
  }));
};
const headers = {
  consolidated: {
    regular: claim => [{
      text: '',
      cellType: 'CommercialProjectToggle',
      renderCell: renderCommercialProjectToggle
    }, {
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$busine;
        return ((_r$data$object$busine = r.data.object.business_unit) === null || _r$data$object$busine === void 0 ? void 0 : _r$data$object$busine.name) || '';
      },
      valueFn: r => {
        var _r$data$object$busine2;
        return ((_r$data$object$busine2 = r.data.object.business_unit) === null || _r$data$object$busine2 === void 0 ? void 0 : _r$data$object$busine2.name) || '';
      }
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_;
        return ((_r$data$object$claim_ = r.data.object.claim_project_report) === null || _r$data$object$claim_ === void 0 ? void 0 : _r$data$object$claim_.project_name) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_2;
        return ((_r$data$object$claim_2 = r.data.object.claim_project_report) === null || _r$data$object$claim_2 === void 0 ? void 0 : _r$data$object$claim_2.project_name) || '';
      }
    }, {
      text: 'Project Type',
      fieldName: 'program_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_3;
        return ((_r$data$object$claim_3 = r.data.object.claim_project_report) === null || _r$data$object$claim_3 === void 0 ? void 0 : _r$data$object$claim_3.program_type) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_4;
        return i18n.t((_r$data$object$claim_4 = r.data.object.claim_project_report) === null || _r$data$object$claim_4 === void 0 ? void 0 : _r$data$object$claim_4.program_type) || '';
      },
      translateValue: true
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => i18n.t(r.data.object.rate_type) || '',
      translateValue: true
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, 'individual' === claim.claim_group.staffing_cost_aggregation_type ? {
      text: 'Employee Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => {
        var _r$data$object$fragme;
        return ((_r$data$object$fragme = r.data.object.fragmentable) === null || _r$data$object$fragme === void 0 ? void 0 : _r$data$object$fragme.name) || '';
      }
    } : null, ['individual', 'function'].includes(claim.claim_group.staffing_cost_aggregation_type) ? {
      text: 'Role/Title',
      fieldName: 'role',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.role,
      valueFn: r => {
        var _r$data$object$fragme2;
        return ((_r$data$object$fragme2 = r.data.object.fragmentable) === null || _r$data$object$fragme2 === void 0 ? void 0 : _r$data$object$fragme2.role) || '';
      }
    } : null, {
      text: 'Salary',
      fieldName: 'base_salary',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme3, _r$data$object$fragme4;
        return (_r$data$object$fragme3 = (_r$data$object$fragme4 = r.data.object.fragmentable) === null || _r$data$object$fragme4 === void 0 ? void 0 : _r$data$object$fragme4.base_salary) !== null && _r$data$object$fragme3 !== void 0 ? _r$data$object$fragme3 : '';
      }
    }, {
      text: 'Bonus',
      fieldName: 'bonus',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme5, _r$data$object$fragme6;
        return (_r$data$object$fragme5 = (_r$data$object$fragme6 = r.data.object.fragmentable) === null || _r$data$object$fragme6 === void 0 ? void 0 : _r$data$object$fragme6.bonus) !== null && _r$data$object$fragme5 !== void 0 ? _r$data$object$fragme5 : '';
      }
    }, {
      text: 'ER NI',
      fieldName: 'national_insurance',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme7, _r$data$object$fragme8;
        return (_r$data$object$fragme7 = (_r$data$object$fragme8 = r.data.object.fragmentable) === null || _r$data$object$fragme8 === void 0 ? void 0 : _r$data$object$fragme8.national_insurance) !== null && _r$data$object$fragme7 !== void 0 ? _r$data$object$fragme7 : '';
      }
    }, {
      text: 'Pension',
      fieldName: 'pension',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme9, _r$data$object$fragme0;
        return (_r$data$object$fragme9 = (_r$data$object$fragme0 = r.data.object.fragmentable) === null || _r$data$object$fragme0 === void 0 ? void 0 : _r$data$object$fragme0.pension) !== null && _r$data$object$fragme9 !== void 0 ? _r$data$object$fragme9 : '';
      }
    }, {
      text: 'Reimbursed',
      fieldName: 'reimbursed_expenses',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme1, _r$data$object$fragme10;
        return (_r$data$object$fragme1 = (_r$data$object$fragme10 = r.data.object.fragmentable) === null || _r$data$object$fragme10 === void 0 ? void 0 : _r$data$object$fragme10.reimbursed_expenses) !== null && _r$data$object$fragme1 !== void 0 ? _r$data$object$fragme1 : '';
      }
    }, {
      text: 'Total',
      fieldName: 'total',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => {
        var _r$data$object$total;
        return (_r$data$object$total = r.data.object.total) !== null && _r$data$object$total !== void 0 ? _r$data$object$total : '';
      }
    }, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? "".concat(Number(r.data.object.reduction_rate_percentage).toFixed(1), "%") : ''
    } : null, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => {
        var _r$data$object$eligib;
        return (_r$data$object$eligib = r.data.object.eligible_total_amount) !== null && _r$data$object$eligib !== void 0 ? _r$data$object$eligib : '';
      }
    } : null, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => {
        var _r$data$object$capita;
        return (_r$data$object$capita = r.data.object.capitalised_costs) !== null && _r$data$object$capita !== void 0 ? _r$data$object$capita : '';
      }
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? "".concat(Number(r.data.object.direct_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? "".concat(Number(r.data.object.indirect_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? "".concat(Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1), "%") : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? "".concat(Number(r.data.object.eligible_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => {
        var _r$data$object$rnd_am;
        return (_r$data$object$rnd_am = r.data.object.rnd_amount) !== null && _r$data$object$rnd_am !== void 0 ? _r$data$object$rnd_am : '';
      }
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => {
        var _r$data$object$pnl_ex;
        return (_r$data$object$pnl_ex = r.data.object.pnl_expenditure) !== null && _r$data$object$pnl_ex !== void 0 ? _r$data$object$pnl_ex : '';
      }
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => {
        var _r$data$object$s1308_;
        return (_r$data$object$s1308_ = r.data.object.s1308_claim) !== null && _r$data$object$s1308_ !== void 0 ? _r$data$object$s1308_ : '';
      }
    }].filter(Boolean),
    realtime: claim => [{
      text: '',
      cellType: 'CommercialProjectToggle',
      renderCell: renderCommercialProjectToggle
    }, {
      text: 'Business Unit',
      cellType: 'BusinessUnitDropdown',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$busine3;
        return ((_r$data$object$busine3 = r.data.object.business_unit) === null || _r$data$object$busine3 === void 0 ? void 0 : _r$data$object$busine3.name) || '';
      },
      valueFn: r => {
        var _r$data$object$busine4;
        return ((_r$data$object$busine4 = r.data.object.business_unit) === null || _r$data$object$busine4 === void 0 ? void 0 : _r$data$object$busine4.name) || '';
      }
    }, {
      text: 'Project Name',
      cellType: 'ProjectSelector',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_5;
        return ((_r$data$object$claim_5 = r.data.object.claim_project_report) === null || _r$data$object$claim_5 === void 0 ? void 0 : _r$data$object$claim_5.project_name) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_6;
        return ((_r$data$object$claim_6 = r.data.object.claim_project_report) === null || _r$data$object$claim_6 === void 0 ? void 0 : _r$data$object$claim_6.project_name) || '';
      }
    }, {
      text: 'Project Type',
      fieldName: 'program_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => {
        var _r$data$object$claim_7;
        return ((_r$data$object$claim_7 = r.data.object.claim_project_report) === null || _r$data$object$claim_7 === void 0 ? void 0 : _r$data$object$claim_7.program_type) || '';
      },
      valueFn: r => {
        var _r$data$object$claim_8;
        return i18n.t((_r$data$object$claim_8 = r.data.object.claim_project_report) === null || _r$data$object$claim_8 === void 0 ? void 0 : _r$data$object$claim_8.program_type) || '';
      },
      translateValue: true
    }, {
      text: 'SME/RDEC',
      fieldName: 'rate_type',
      disabled: true,
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.rate_type || '',
      valueFn: r => i18n.t(r.data.object.rate_type) || '',
      translateValue: true
    }, {
      text: 'Methodology Item',
      fieldName: 'rate_type',
      cellType: 'text',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.claim_project_report.cost_methodology_type || '',
      disabled: true,
      valueFn: r => r.data.object.claim_project_report.cost_methodology_type || '',
      translateValue: true
    }, 'individual' === claim.claim_group.staffing_cost_aggregation_type ? {
      text: 'Employee Name',
      fieldName: 'name',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.name,
      valueFn: r => {
        var _r$data$object$fragme11;
        return ((_r$data$object$fragme11 = r.data.object.fragmentable) === null || _r$data$object$fragme11 === void 0 ? void 0 : _r$data$object$fragme11.name) || '';
      }
    } : null, ['individual', 'function'].includes(claim.claim_group.staffing_cost_aggregation_type) ? {
      text: 'Role/Title',
      fieldName: 'role',
      cellType: 'text',
      model: 'fragmentable',
      filterableByText: true,
      sortable: true,
      valueFnForSortAndFilter: r => r.data.object.fragmentable.role,
      valueFn: r => {
        var _r$data$object$fragme12;
        return ((_r$data$object$fragme12 = r.data.object.fragmentable) === null || _r$data$object$fragme12 === void 0 ? void 0 : _r$data$object$fragme12.role) || '';
      }
    } : null, {
      text: 'Salary',
      fieldName: 'base_salary',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme13, _r$data$object$fragme14;
        return (_r$data$object$fragme13 = (_r$data$object$fragme14 = r.data.object.fragmentable) === null || _r$data$object$fragme14 === void 0 ? void 0 : _r$data$object$fragme14.base_salary) !== null && _r$data$object$fragme13 !== void 0 ? _r$data$object$fragme13 : '';
      }
    }, {
      text: 'Bonus',
      fieldName: 'bonus',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme15, _r$data$object$fragme16;
        return (_r$data$object$fragme15 = (_r$data$object$fragme16 = r.data.object.fragmentable) === null || _r$data$object$fragme16 === void 0 ? void 0 : _r$data$object$fragme16.bonus) !== null && _r$data$object$fragme15 !== void 0 ? _r$data$object$fragme15 : '';
      }
    }, {
      text: 'ER NI',
      fieldName: 'national_insurance',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme17, _r$data$object$fragme18;
        return (_r$data$object$fragme17 = (_r$data$object$fragme18 = r.data.object.fragmentable) === null || _r$data$object$fragme18 === void 0 ? void 0 : _r$data$object$fragme18.national_insurance) !== null && _r$data$object$fragme17 !== void 0 ? _r$data$object$fragme17 : '';
      }
    }, {
      text: 'Pension',
      fieldName: 'pension',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme19, _r$data$object$fragme20;
        return (_r$data$object$fragme19 = (_r$data$object$fragme20 = r.data.object.fragmentable) === null || _r$data$object$fragme20 === void 0 ? void 0 : _r$data$object$fragme20.pension) !== null && _r$data$object$fragme19 !== void 0 ? _r$data$object$fragme19 : '';
      }
    }, {
      text: 'Reimbursed',
      fieldName: 'reimbursed_expenses',
      cellType: 'number',
      model: 'fragmentable',
      valueFn: r => {
        var _r$data$object$fragme21, _r$data$object$fragme22;
        return (_r$data$object$fragme21 = (_r$data$object$fragme22 = r.data.object.fragmentable) === null || _r$data$object$fragme22 === void 0 ? void 0 : _r$data$object$fragme22.reimbursed_expenses) !== null && _r$data$object$fragme21 !== void 0 ? _r$data$object$fragme21 : '';
      }
    }, {
      text: 'Total',
      fieldName: 'total',
      cellType: 'number',
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.total),
      valueFn: r => {
        var _r$data$object$total2;
        return (_r$data$object$total2 = r.data.object.total) !== null && _r$data$object$total2 !== void 0 ? _r$data$object$total2 : '';
      }
    }, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Reduction Factor',
      fieldName: 'reduction_rate_percentage',
      disabled: true,
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.reduction_rate_percentage),
      valueFn: r => r.data.object.reduction_rate_percentage != null ? "".concat(Number(r.data.object.reduction_rate_percentage).toFixed(1), "%") : ''
    } : null, claim.is_staffing_cost_rate_reduction_required ? {
      text: 'Eligible Total',
      fieldName: 'eligible_total_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_total_amount),
      valueFn: r => {
        var _r$data$object$eligib2;
        return (_r$data$object$eligib2 = r.data.object.eligible_total_amount) !== null && _r$data$object$eligib2 !== void 0 ? _r$data$object$eligib2 : '';
      }
    } : null, {
      text: 'Capitalised Costs (if any)',
      fieldName: 'capitalised_costs',
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.capitalised_costs),
      valueFn: r => {
        var _r$data$object$capita2;
        return (_r$data$object$capita2 = r.data.object.capitalised_costs) !== null && _r$data$object$capita2 !== void 0 ? _r$data$object$capita2 : '';
      }
    }, {
      text: 'Direct R&D%',
      fieldName: 'direct_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.direct_rnd_percentage),
      valueFn: r => r.data.object.direct_rnd_percentage != null ? "".concat(Number(r.data.object.direct_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Indirect R&D%',
      fieldName: 'indirect_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.indirect_rnd_percentage),
      valueFn: r => r.data.object.indirect_rnd_percentage != null ? "".concat(Number(r.data.object.indirect_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'Consolidated % of Time Spent',
      fieldName: 'consolidated_percentage_of_time_spent',
      cellType: 'percentage',
      decimalScale: 1,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.consolidated_percentage_of_time_spent),
      valueFn: r => r.data.object.consolidated_percentage_of_time_spent != null ? "".concat(Number(r.data.object.consolidated_percentage_of_time_spent).toFixed(1), "%") : ''
    }, {
      text: 'Eligible R&D %',
      fieldName: 'eligible_rnd_percentage',
      cellType: 'percentage',
      decimalScale: 1,
      disabled: true,
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.eligible_rnd_percentage),
      valueFn: r => r.data.object.eligible_rnd_percentage != null ? "".concat(Number(r.data.object.eligible_rnd_percentage).toFixed(1), "%") : ''
    }, {
      text: 'R&D Amount',
      fieldName: 'rnd_amount',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.rnd_amount),
      valueFn: r => {
        var _r$data$object$rnd_am2;
        return (_r$data$object$rnd_am2 = r.data.object.rnd_amount) !== null && _r$data$object$rnd_am2 !== void 0 ? _r$data$object$rnd_am2 : '';
      }
    }, {
      text: 'P&L R&D Expenditure',
      fieldName: 'pnl_expenditure',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.pnl_expenditure),
      valueFn: r => {
        var _r$data$object$pnl_ex2;
        return (_r$data$object$pnl_ex2 = r.data.object.pnl_expenditure) !== null && _r$data$object$pnl_ex2 !== void 0 ? _r$data$object$pnl_ex2 : '';
      }
    }, {
      text: 's1308 Claim',
      fieldName: 's1308_claim',
      disabled: true,
      cellType: 'number',
      sortable: true,
      valueFnForSortAndFilter: r => Number(r.data.object.s1308_claim),
      valueFn: r => {
        var _r$data$object$s1308_2;
        return (_r$data$object$s1308_2 = r.data.object.s1308_claim) !== null && _r$data$object$s1308_2 !== void 0 ? _r$data$object$s1308_2 : '';
      }
    }].filter(Boolean)
  }
};
export const staffingCostFragmentTableSettings = {
  headers
};